var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholderDark24 = function SvgPlaceholderDark24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.167 7 12 11.167 2.833 7M12 11.167V22",
    stroke: "#F6F7F8",
    strokeOpacity: 0.72,
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.833 6.167 12 2l9.167 4.167v11.666L12 22l-9.167-4.167V6.167Z",
    stroke: "#F6F7F8",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
};
export default SvgPlaceholderDark24;